(function ( $ ) {
     $.fn.ajaxNews = function (options) {
         var settings = $.extend({
            someOption: ""
        }, options);

        var container      = $('.news-container');
        var container_btn  = $('.news-container-btn');
        var objLink        = $('.btn-ajax-news');

        function _init() {
            $(objLink).click(function(e) {
                _initView(objLink);
            })
        }


        function _initView(o){
            container_btn.addClass('loading');

            $.ajax({
              url: ajaxurl,
              data : { 'action': 'load_more_news', 'page': o.attr('data-page'), 'exclude-cat': o.attr('data-exclude-cat') },
              type : 'POST',
              success: function (json) {
                 container_btn.removeClass('loading');
                 container.append( json.html );
                 if(json.paged > 1){
                     objLink.attr('data-page',json.paged);
                 }else{
                     container_btn.hide();
                 }

                 $('.lazy').lazy({
                   effect: "fadeIn",
                   effectTime: 500,
                   threshold: 0,
                   afterLoad: function(element) {
                         $(element).removeClass('blur-load');
                   }
                 });
              }
            });
        }



        _init();

       return {
         reload:_init,
       };
    };
}( jQuery ));

$("body").ajaxNews();
